import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Row, Col } from 'core/components/ui'
import SVG from 'core/components/svg'
import svg from 'assets/svg'
import { font, greys } from 'assets/themes/theme-default'
import FilterTitle from '../title'

export const IconWrapper = styled.div`
  background: ${props => props.theme.colors.color2.bg};
  width: 40px;
  height: 40px;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const StyledSVG = styled(SVG)`
  width: 20px;
  height: 20px;
  fill: ${greys.light4};
`

const FilterItemWrapper = styled(Col)`
  cursor: pointer;
  color: ${props => props.theme.colors.color2.bg};
  margin-bottom: 15px;
  font-size: ${font.size.sm};
  line-height: 18px;
  &.activ {
    color: ${props => props.theme.colors.color1.bg};
    ${IconWrapper} {
      background: ${props => props.theme.colors.color1.bg};
    }
  }
`

/************* */

const Ecology = props => {
  const { intl, onChangeFilter, filters, filtersDatas } = props

  const { ecologies } = filters
  const ecologiesList = filtersDatas.ecologies

  const handleClick = item => {
    const isSelected = !ecologies ? false : ecologies.filter(el => el === item.value).length > 0

    let extendedEcologiesValues = ecologies ? [...ecologies] : []

    if (!isSelected) {
      extendedEcologiesValues.push(item.value)
    } else {
      extendedEcologiesValues = ecologies.filter(el => el !== item.value)
    }

    const extendedFiltersValues = {
      ...filters,
      ecologies: extendedEcologiesValues
    }
    onChangeFilter(extendedFiltersValues)
  }

  const renderIcon = id => {
    let icon

    switch (id) {
      case 1:
        icon = svg.cloud
        break
      default:
        break
    }
    return icon ? (
      <IconWrapper>
        <StyledSVG svg={icon} data-test="stock-vehicles-list-filters-ecology-FilterItemIcon" />
      </IconWrapper>
    ) : null
  }

  const renderItem = item => {
    const { label, value } = item

    const isSelected = !ecologies ? false : ecologies.filter(el => el === item.value).length > 0

    return (
      <FilterItemWrapper
        key={label}
        onClick={() => handleClick(item)}
        className={isSelected ? 'activ' : ''}
        data-test="stock-vehicles-list-filters-ecology-FilterItemWrapper"
      >
        <Row type="flex" gutter={10} style={{ alignItems: 'center' }}>
          <Col>{renderIcon(value)}</Col>
          <Col>
            <FormattedMessage
              id={label}
              data-test="stock-vehicles-list-filters-ecology-FilterItemLabel"
            />
          </Col>
        </Row>
      </FilterItemWrapper>
    )
  }

  return (
    <div data-test="component-stock-vehicles-list-filters-ecology">
      <FilterTitle
        label={intl.formatMessage({
          id: 'stock-vehicles-list-filters-ecology-title'
        })}
        data-test="stock-vehicles-list-filters-ecology-title"
      />
      <Row type="flex">{ecologiesList && ecologiesList.map(item => renderItem(item))}</Row>
    </div>
  )
}

Ecology.propTypes = {
  filtersDatas: PropTypes.shape().isRequired,
  filters: PropTypes.shape().isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  intl: PropTypes.shape().isRequired
}

export default injectIntl(Ecology)
